import React from "react";

import { useTranslate } from "localization";
import styled from "styled-components";
import cssVar from "theme/vars";
import { Alert } from "ui/core";

const Empty: React.FC = () => {
  const { translate } = useTranslate();

  return (
    <EmptyWrapper>
      <Alert variant="empty">{translate("emptyAlert")}</Alert>
    </EmptyWrapper>
  );
};

const EmptyWrapper = styled.div`
  padding: ${cssVar("spacing/5")};
  width: 100%;
  display: grid;
  place-content: center;
  text-align: center;
`;

export default Empty;
